import {
  CreateExternalCryptoAddressInput,
  CryptoTransfersVASPQuery$data,
} from '@bts-web/data-layer/server';
import { WalletForm } from '../../Reusable/WalletForm/WalletForm';
import { TTransfersNextStepStateWithActions } from '../../../utils/useTransfersNextStepState.client';
import { TCryptoTransferTranslations } from '../../../utils/getCryptoTransferTranslations';
import { TransfersSendStepsIds, WalletOwnerType } from '../../../types';
import { useTransferWarningModal } from '../hooks/useTransferWarningModal';

interface AddNewWalletScreenProps {
  state: TTransfersNextStepStateWithActions;
  translations: TCryptoTransferTranslations;
  walletHosts: CryptoTransfersVASPQuery$data['cryptoTransfersVASP'];
}

const AddNewWalletScreen = ({
  state,
  translations,
  walletHosts,
}: AddNewWalletScreenProps) => {
  const {
    selectedAssetData,
    selectedNetworkData,
    setAddressInput,
    addressInput,
    walletOwnerType,
  } = state;

  const isLegalEntity = walletOwnerType === WalletOwnerType.LegalEntity;

  const { showTransferWarningModal } = useTransferWarningModal(
    state,
    translations,
  );

  const handleCreate = (newAddress: CreateExternalCryptoAddressInput) => {
    const memoIsMissing =
      selectedNetworkData?.destinationTag && !newAddress.destinationTag;

    setAddressInput(newAddress);

    if (memoIsMissing) {
      state.changeToPageAndBindActions({
        pageId: TransfersSendStepsIds.MemoIsMissing,
        newBackAction: {
          pageId: TransfersSendStepsIds.AddNewWallet,
          type: 'page',
        },
      });

      return;
    }

    showTransferWarningModal(newAddress);
  };

  return (
    <WalletForm
      recipientNameLabel={
        isLegalEntity
          ? translations.registeredBusinessName
          : translations.recipientsName
      }
      actionLabel={translations.send}
      translations={translations}
      assetData={selectedAssetData}
      networkData={selectedNetworkData}
      walletHosts={walletHosts}
      onCreate={handleCreate}
      defaultAddressInput={addressInput}
      title={translations.walletDetails}
      submitButtonLabel={translations.createNewWallet}
      isLegalEntity={isLegalEntity}
    />
  );
};

export { AddNewWalletScreen };
